/**
 * Inline SVG glyphs shared by the lobby and the pause overlay.
 *
 * Stroke-drawn, `currentColor` throughout, so colour and emphasis are always
 * the stylesheet's decision and the game ships no image assets.
 */

/** A small microphone. */
export const MIC_SVG =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
  'stroke-linecap="round"><rect x="9" y="3" width="6" height="11" rx="3"/>' +
  '<path d="M5 11a7 7 0 0 0 14 0"/><line x1="12" y1="18" x2="12" y2="21"/></svg>';

/** The same microphone with a slash: muted. */
export const MIC_SVG_MUTED =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
  'stroke-linecap="round"><rect x="9" y="3" width="6" height="11" rx="3"/>' +
  '<path d="M5 11a7 7 0 0 0 14 0"/><line x1="12" y1="18" x2="12" y2="21"/>' +
  '<line x1="4" y1="3" x2="20" y2="21"/></svg>';
